import VerificationTimoutModal from './VerificationTimoutModal';
export default VerificationTimoutModal;